import classNames from 'classnames'

import { Button } from '../Button'
import { Icon } from '@/Atomic/Atoms/Icon'
import { StringText } from '@/Atomic/Atoms/StringText'

import './InfoBox.scss'

export type InfoBoxType = 'info' | 'danger' | 'warning' | 'success' | 'neutral'
export type InfoBoxIconPosition = 'top' | 'side'

export interface InfoBoxProps {
  text?: string
  children?: React.ReactNode
  type?: InfoBoxType
  showIcon?: boolean
  iconPosition?: InfoBoxIconPosition
  icon?: string
  className?: string
  onClose?: () => void
}

export const InfoBox: React.FC<InfoBoxProps> = ({
  type = 'info',
  text,
  children,
  showIcon = true,
  iconPosition = 'top',
  icon,
  className,
  onClose,
}) => {
  const iconConfig = {
    info: { icon: icon || 'info-circle-solid', color: 'info' as const },
    danger: { icon: icon || 'alert-circle-solid', color: 'danger' as const },
    warning: { icon: icon || 'alert-circle-solid', color: 'warning' as const },
    success: { icon: icon || 'check-circle-solid', color: 'success' as const },
    neutral: { icon: icon || 'info-circle-solid', color: 'default' as const },
  }[type] || { icon: icon || 'info-circle-solid', color: 'info' as const }

  const showHeader = onClose || (showIcon && iconPosition === 'top')

  return (
    <div
      className={classNames(
        'm-info-box',
        type,
        `icon-${iconPosition}`,
        className,
      )}
    >
      {showHeader && (
        <div className="header">
          {showIcon && iconPosition === 'top' ? (
            <Icon
              icon={iconConfig.icon}
              color={iconConfig.color}
              className="icon"
            />
          ) : (
            <span className="spacer" aria-hidden />
          )}
          {onClose && <Button onClick={onClose} variant="icon" icon="cross" />}
        </div>
      )}
      <div className="body">
        {showIcon && iconPosition === 'side' && (
          <Icon
            icon={iconConfig.icon}
            color={iconConfig.color}
            className="icon"
          />
        )}
        <div className="content">
          {children ? <>{children}</> : <StringText>{text}</StringText>}
        </div>
      </div>
    </div>
  )
}

export default InfoBox
